<template>
  <div class="dialog-wrapper">
    <el-dialog
      :title="'专家汇总表'"
      :visible.sync="isOpen"
      width="580px"
      :close-on-click-modal="false"
      :before-close="handleDialogClose"
    >
      <div v-if="!isShowLoading" >
        <vue-scroll :ops="ops">
          <div class="scroll-content">
            <el-form
              ref="formDataRom"
              :model="formData"
              :rules="formDataRules"
              label-width="130px"
            >
              <span style="margin-left: 20px;"
                class="temp-file"
              >下载专家汇总表后打印并签字扫描后上传：<span
                class="title"
                title="点击导出评分表"
                style="font-size:16px;cursor:pointer"
                @click="downFile()"
              >下载专家汇总表</span
              >/<span
                class="title"
                title="点击查看评分表"
                style="font-size:16px;cursor:pointer"
                @click="downFileCha()"
              >查看专家汇总表</span
              ></span>
              <el-form-item label="专家汇总表(签字)" :error="uploadErroeMsg" :rules="{required: true}" style="margin-top:20px">
                <el-upload
                  class="yioks-form-item"
                  :action="uploadPath"
                  :on-remove="handleRemoveFile"
                  :before-upload="beforeUpload"
                  :on-success="handleSuccessFiler"
                  multiple
                  :limit="1"
                  :on-exceed="handleExceed"
                  :file-list="uploadFileList"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                      <a style="color: #666;">单个上传文件大小不能超过50M,最多上传1个文件。</a>
                  </div>
                </el-upload>
                <template v-for="(file, index) in uploadFileList">
                  <a :href="'http://kkfv.yioks.cn/onlinePreview?url='+encodeURIComponent($Base64.encode(file.url))" target="_blank">
                    <el-button size="mini" type="primary" >查看</el-button>
                  </a>
                </template>
              </el-form-item>
            </el-form>
          </div>
        </vue-scroll>
      </div>
      <div class="empty-box" v-if="isShowLoading">
        <yioks-loading v-if="isShowLoading"></yioks-loading>
      </div>
      <div slot="footer" class="footer-btn-group">
        <el-button type="primary" :disabled="isShowLoading" :loading="addbtnLoading" @click="handleDialogFormAction(true)"
          >确 定</el-button
        >
        <el-button type="danger" :disabled="isShowLoading" :loading="addbtnLoading" @click="handleDialogFormAction(false)"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  postTargetSubmit,
  putTargetSubmit,
  deleteTargetSubmit,
  getSecondTargetFileAndLabel,
  uploadBaseScoreFile,
  baseScoreFileListSummary,
  downloadBaseScoreSummaryFile,
} from "@/api/performance";
import { requiredItem } from "@/assets/js/formRules";
import { ops } from "@/utils/scrollIndialog";
import storage from '@/utils/storage'
import mixinAppConfig from '@/mixin/mixinAppConfig';
import { downloadByJs } from "@/utils/commen";

export default {
  mixins: [mixinAppConfig],
  props: {
    isOpen: {
      type: Boolean,
      default: false,
      required: true,
    },
    isDetailsNeed: {
      type: false,
      default: false,
      required: false,
    },

    isEdit: {
      type: Boolean,
      default: false,
      required: false,
    },

    stageUuid: {
      type: String,
      default: "",
      required: true,
    },

  },

  data() {
    return {
      ops,
      requiredItem,
      // uploadPath: "/api/zuxie/guozi/upload/jixiao",
      uploadPath: "/api/zuxie/guozi/upload/uploadJixiaoFile",
      formData: {
        fileFormList: [
          // {
          //   fileName: '',
          //   fileType: '',
          //   fileUrl: '',
          //   md5: '',
          //   stageUuid: '',
          //   targetUuid: '',
          //   // uuid: '',
          // }
        ],
        stageUuid:"",
        scoreType:"summaryScore",
      },
      isNeedFile:1,
      formDataRules: {},
      uploadErroeMsg: "", // 文件上传信息校验
      uploadFileList: [], // 文件上传组件 - 文件列表
      uploadFileList_edit: [], // 文件上传组件 - 编辑中新增文件
      fileListChangedFlag: false,
      tempFile: {},
      targetUuid: "",
      isShowLoading: false,
      userRole: storage.get('userInfo').userRole,
      addbtnLoading: false,
    };
  },

  computed: {

  },

  created() {
    this.setFormDataFormate();
  },

  methods: {
    downloadFile(file) {
      // 下载文件的方法
//      window.open(file.url)
    },
    // 设置表单原始内容
    setFormDataFormate() {
      baseScoreFileListSummary(this.stageUuid)
      .then(res => {
        this.isShowLoading = false;
        if(res.code) {
          this.$message.error(res.msg);
          return
        }

        // 处理已上传文件列表
        if (res && res.length) {
          this.uploadFileList = [];
          res.map((item) => {
            const { fileName, fileUrl, uuid } = item;
            const fileObj = {
              fileName: fileName,
              fileUrl: fileUrl,
              uuid: uuid,
            };
            if (this.isEdit) {
              this.uploadFileList_edit.push(fileObj);
            }
            this.formData.fileFormList.push(fileObj);


            this.uploadFileList.push({
              name: item.fileName,
              url: item.fileUrl,
              id: item.uuid,
              meta: item,
            })
          });
        }
      })
      .catch(err => {
        this.isShowLoading = false;
        console.error('err', err)
      })
    },

    //  关闭弹窗
    handleDialogClose() {
      if(this.isShowLoading) return
      this.setDialogStatus(false);
    },

    // 设置弹窗状态
    setDialogStatus(flag) {
      this.$emit("update:isOpen", flag);
    },

    //  设置弹窗回调事件
    setCallBackFunction(dialogStatus, confirmStatus) {
      if (!dialogStatus) this.handleDialogClose();
      this.$emit("closeDialogCallBackSummary", dialogStatus, confirmStatus);
    },

    downFile(){
      downloadBaseScoreSummaryFile(this.stageUuid)
      .then(res => {
        this.isShowLoading = false;
        if(res.code) {
          this.$message.error(res.msg);
          return
        }
        const { fileName, filePath } = res;
        const transferPath = this.$yioksConfig.transferBaseOnly(filePath)
        downloadByJs(transferPath, fileName);
      })
      .catch(err => {
        this.isShowLoading = false;
        console.error('err', err)
      })
    },

    downFileCha(){
      downloadBaseScoreSummaryFile(this.stageUuid)
        .then(res => {
          this.isShowLoading = false;
          if(res.code) {
            this.$message.error(res.msg);
            return
          }
          const { filePath } = res;
          const transferPath = this.$yioksConfig.transferBaseOnly(filePath);
          const fileUrl = window.location.origin + transferPath + "?V=" + new Date().getTime();
          // 修复：移除多余字符
          window.open('http://kkfv.yioks.cn/onlinePreview?url='+encodeURIComponent(this.$Base64.encode(fileUrl)));
        })
        .catch(err => {
          this.isShowLoading = false;
          console.error('err', err)
        })
    },

    // 弹窗表单操作按钮
    handleDialogFormAction(status) {
      if (status) {
        this.$refs.formDataRom.validate((valid) => {
          if (!this.formData.fileFormList.length) {
            this.addbtnLoading = false
            this.uploadErroeMsg = "请上传评分表";
            return; // 无证明材料不允许 提交
          }

          this.addbtnLoading = true
          this.uploadErroeMsg = "";
          this.formData.stageUuid = this.stageUuid;
          const submitData = this.formData;
          uploadBaseScoreFile(submitData)
          .then((res) => {
            this.addbtnLoading = false
            if (res.code) {
              this.$message.error(res.msg);
              this.setCallBackFunction(true, true);
              return;
            }
            this.$message.success('上传成功')
            this.setCallBackFunction(false, true);
          })
          .catch((err) => {
            this.addbtnLoading = false
            this.setCallBackFunction(true, true);
            console.error("err", err);
          });
        });
      } else {
        this.handleDialogClose();
      }
    },

    // 移除文件
    handleRemoveFile(file, fileList) {
      this.fileListChangedFlag = true;
      const  { meta } = file;
      this.uploadFileList = this.uploadFileList.filter((item) => {
        const  status = file.url !== item.url;
        return status
      })
      this.$set(this.formData, "fileFormList", this.uploadFileList);
      if(this.isEdit) {
        this.uploadFileList_edit = this.uploadFileList_edit.filter(item => {
          const  status = file.url !== item.url;
          return status
        })
      }
    },

    //  证明材料提交成功
    handleSuccessFiler(res, file) {
      if (this.uploadErroeMsg) this.uploadErroeMsg = "";
      this.fileListChangedFlag = true;
      const { fileMd5, fileName, fileTmp, suffix, url } = res;
      const fileObj = {
        name: fileName,
        url: url,
        fileName: fileName,
        md5: fileMd5,
        fileUrl: url,
      };
      if (this.isEdit) {
        this.uploadFileList_edit.push(fileObj);
      }
      this.uploadFileList.push(fileObj);
      this.$set(this.formData, "fileFormList", this.uploadFileList);
    },

    // 上传文件检测
    beforeUpload(file) {
      // const fileReg = /^.*\.(pptx|ppt)$/i
      // const fileType = fileReg.test(file.name)
      const fileLimit = file.size / 1024 / 1024 < 50;
      if (!fileLimit) {
        this.$message.error("单个上传文件大小不能超过50M");
      }
      // if (fileType) {
      //   this.$message.error("暂不支持PPT上传");
      // }
      return fileLimit;
    },

    // 文件上传超出限制
    handleExceed(files, fileList) {
      this.$message.warning(`当前最多上传1个文件，本次上传已经超过了限制。`);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.temp-file
  color #606266
  .title
    color $green_color !important
.label-wrapper
  width 340px
  /*p*/
  /*  white-space nowrap*/
  /*  overflow hidden*/
  /*  text-overflow ellipsis*/
.form-content-wrapper
  height 380px
  .scroll-content
    margin-right 20px

.empty-box
  height: 240px
</style>

<style lang="stylus" scoped>
.yioks-form-item
  width 340px
.footer-btn-group
  width 60%
  margin 0 auto
  display flex
  justify-content space-around
.el-upload__tip
  display: flex
  flex-direction column
  a
    line-height: 20px !important
</style>
